import request from '@/utils/request'
import setting from '@/settings'
import qs from 'qs'
const apiUrl = setting.apiUrl

/**
 * 获取招生信息左边树列表
 * @param data
 */
export const leftEnrollmentInformationTreeSearch = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/enrollmentinformation/leftEnrollmentInformationTreeSearch`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
* 获取招生信息列表
* @param data
*/
export const querySchoolListByBusinessId = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/school/querySchoolListByBusinessId`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
* 获取招生信息列表总数
* @param data
*/
export const querySchoolListByBusinessIdCount = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/school/querySchoolListByBusinessIdCount`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取招生简章详情
 * @param data
 */
export const schoolIntroduceDetail = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/schoolIntroduce/detail`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
* 获取院校基础资料
* @param data
*/
export const schoolDetailDetail = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/schoolDetail/detail`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 招生简章新增&修改
 * @param data
 */
export const schoolIntroduceInsert = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/schoolIntroduce/insert`,
    method: 'post',
    data: data
  })

/**
* 更新基础信息
* @param data
*/
export const schoolDetailUpdate = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/schoolDetail/update`,
    method: 'post',
    data: data
  })

/**
* 广告新增&修改
* @param data
*/
export const addadvertisingUpdate = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/addadvertising/addadvertisingUpdate`,
    method: 'post',
    data: data
  })

/**
 * 获取广告列表
 * @param data
 */
export const getAdvertisinglist = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/agent/getAdvertisinglist`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 招生信息列表启用
 * @param data
 */
export const enable = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/schoolDetail/enable`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 招生列表禁用
 * @param data
 */
export const disable = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/schoolDetail/disable`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 年级专业列表总数
 * @param data
 */
export const getGradeSubjectListCount = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/gradeSubject/getGradeSubjectListCount`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 年级专业列表
 * @param data
 */
export const getGradeSubjectList = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/gradeSubject/getGradeSubjectList`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 删除
 * @param data
 */
export const gradeSubjectDelete = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/gradeSubject/delete`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 新增保存
 * @param data
 */
export const gradeSubjectInsert = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/gradeSubject/insert`,
    method: 'post',
    data: data
  })

/**
 * 年级专业已选择数据
 * @param data
 */
export const getGradeSubjectListNoPage = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/gradeSubject/getGradeSubjectListNoPage`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取年级专业总条数
 * @param data
 */
export const getAddGradeSubjectListCount = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/gradeSubject/getAddGradeSubjectListCount`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取年级专业数据
 * @param data
 */
export const getAddGradeSubjectList = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/gradeSubject/getAddGradeSubjectList`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 根据院校ID删除全部年级专业
 * @param data
 */
export const deleteAllGradeSubject = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/gradeSubject/deleteAll`,
    method: 'post',
    data: qs.stringify(data)
  })

  
/**
 * 可添加院校收费项目配置列表
 * @param data
 */
export const getAddSchoolFeeStandardList = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/schoolGradeSubjectFee/getAddSchoolFeeStandardList`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 可添加年级专业列表总数
 * @param data
 */
export const getAddGradeSubjectFeeListCount = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/schoolGradeSubjectFee/getAddGradeSubjectListCount`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 批量新增
 * @param data
 */
export const InsertSchoolGradeSubjectFee = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/schoolGradeSubjectFee/insert`,
    method: 'post',
    data: data
  })

/**
 * 根据ID删除
 * @param data
 */
export const deleteSchoolGradeSubjectFeeById = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/schoolGradeSubjectFee/delete`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 根据院校ID删除全部
 * @param data
 */
export const deleteAllSchoolGradeSubjectFee = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/schoolGradeSubjectFee/deleteAll`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 已配置列表
 * @param data
 */
export const getSchoolGradeSubjectFeeList = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/schoolGradeSubjectFee/getSchoolGradeSubjectFeeList`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 已配置条数
 * @param data
 */
export const getSchoolGradeSubjectFeeListCount = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/schoolGradeSubjectFee/getSchoolGradeSubjectFeeListCount`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 已配置全部
 * @param data
 */
export const getAllSchoolGradeSubjectFee = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/schoolGradeSubjectFee/all`,
    method: 'post',
    data: qs.stringify(data)
  })